import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  tableCell: {
    borderRight: `1px solid ${theme.palette.tableBorder}`,
  },
  topLeftGrid: {
    '& .MuiTableCell-root': {
      borderRight: 'none',
    },
  },
  topRightGrid: {
    '& .MuiTableCell-root': {
      borderRight: 'none',
    },
  },
  bottomLeftGrid: {
    '& .MuiTableCell-root': {
      borderRight: 'none',
    },
  },
}));

export default useStyles;
